<template>
  <img :src="require('@/assets/images/project-detail/poster/' + sImgUrl)" alt="" />
</template>

<script>
export default {
  name: "image-view",
  data() {
    return {
      sImgUrl: "",
    };
  },
  created() {
    // 获取id,展示不同的图片
    let id = this.$route.query.id;
    if (id === 971) {
      this.sImgUrl = "red-poster.jpg";
    } else if (id === 944 || id === 190 || id === 191 || id === 932) {
      this.sImgUrl = "yellow-poster.jpg";
    } else if (id === 417) {
      this.sImgUrl = "green-poster.jpg";
    } else if (id === 426) {
      this.sImgUrl = "blue-poster-jpg.jpg";
    } else if (id === 683) {
      this.sImgUrl = "purple-poster.jpg";
    }else if(id===688){
         this.sImgUrl = "zhong.jpg";
    }else if(id===530){
          this.sImgUrl = "res-kuang-poster.jpg";
    }
  },
};
</script>

<style scoped>
img {
  width: 100%;
  height: auto;
}
</style>
